import classes from "./PartnerReport.module.css";
import { CloseIcon, PrintIcon } from "../../../components/Svgs";
import moment from "moment";
import AnalyticsCard from "../components/AnalyticsCard/AnalyticsCard";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../../../components/Loader/Loader";
import Table from "../components/Table/Table";
import { getMonthlyReportData } from "../../../utils/api";
import { getOrgType } from "../../../utils/utils";

const formatCurrency = (num) => {
  return num?.toFixed(2).replace(".", ",");
};
const PartnerReport = ({ closeModalHandler, date }) => {
  const [reportData, setReportData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const { orgData } = useSelector((state) => state.orgData);
  const orgType = getOrgType(orgData?.org?.type);
  const orgId = orgData.org.orgId;

  const getReportdata = useCallback(async () => {
    const reportData = await getMonthlyReportData(date, orgId, orgType);
    setReportData(reportData);
    setIsLoading(false);
  }, [orgId, date]);

  useEffect(() => {
    getReportdata();
  }, [getReportdata]);

  if (isLoading)
    return (
      <div className={classes.report} style={{ padding: 0 }}>
        <Loader />
      </div>
    );

  const analyticsData = [
    {
      title: "Albums CREATED",
      value: reportData?.numEventsCurrentMonth,
    },
    {
      title: "Orders",
      value: reportData?.numOrdersCurrentMonth,
    },
    {
      title: `Profit (ZAR)`,
      value: formatCurrency(reportData?.profit),
    },
  ];

  const billingOverview = {
    title: "Billing Overview",
    labels: ["Service / Item", "Amount", `Sum (ZAR)`],
    body: [
      ["Order fee (On-Site Sales)", reportData?.totalOrdersCash, formatCurrency(reportData?.totalFeeCash)],
      ["Order fee (Giveaway)", reportData?.totalOrdersGiveaway, formatCurrency(reportData?.totalFeeGiveaway)],
      ["Order fee (Online Shop)", reportData?.totalOrdersBank, formatCurrency(reportData?.totalFeeBank)],
    ],
    footer: (
      <>
        {(reportData?.totalOrdersCash > 0 ||
          reportData?.totalOrdersGiveaway > 0 ||
          reportData?.totalOrdersBank > 0) && (
          <tr>
            <td colSpan={2}>Total Floodin Fee</td>
            <td>{formatCurrency(reportData?.totalFee)}</td>
          </tr>
        )}
        {/* <tr>
          <th>Online-Shop Revenue Share</th>
          <th>{reportData?.totalOrdersBank}</th>
          <td>{formatCurrency(reportData?.revenueBankShare)}</td>
        </tr> */}
        <tr>
          <td colSpan={2}>Profit</td>
          <td>{formatCurrency(reportData?.profit)}</td>
        </tr>
      </>
    ),
    note: reportData?.profit > 0 && (
      <>
        <th>
          <p>
            <span>You will receive a payout of ZAR {formatCurrency(Math.abs(reportData?.profit))}</span> to
            the following bank account:
            <br /> Account Name: {reportData?.accountName}, Bank: {reportData?.bankName}, Branch Code:{" "}
            {reportData?.branchCode}, Account Number: {reportData?.accountNumber}
          </p>
        </th>
        <th></th>
        <th></th>
      </>
    ),
  };

  const revenuePerTeamMember = {
    title: "Revenue per Operator",
    labels: ["Operator", "Albums created", "Orders", "Revenue (%)", "Profit"],
    body: reportData?.operatorLineItems.map((i, idx) => {
      let values = [];
      for (const key in i) {
        var value = i[key];
        if (key === "profitPortion") {
          values.push(`${value}%`);
        } else if (key === "profit") {
          values.push(formatCurrency(value));
        } else if (key !== "revenue" && key !== "revenuePortion") {
          values.push(value);
        }
      }
      return values;
    }),
  };

  return (
    <div className={classes.report}>
      <div className={classes.container}>
        <div className={classes.header}>
          <div>
            <h4>{reportData?.partnerName}</h4>
            <h2>{moment(date).format("MMMM yy")}</h2>
          </div>
          <div className={classes.logo}>
            <img src="/blue-logo.png" alt="logo" />
          </div>

          <div className={classes.print} onClick={() => window.print()}>
            <PrintIcon />
            <span>Print / PDF</span>
          </div>
          <div className={classes["close-icon"]} onClick={closeModalHandler}>
            <CloseIcon />
          </div>
        </div>

        <div className={classes.analytics}>
          {analyticsData.map((i) => (
            <AnalyticsCard key={i.title} title={i.title} value={i.value} />
          ))}
        </div>

        <div className={classes.tables}>
          <Table data={billingOverview} />
          <Table data={revenuePerTeamMember} />
        </div>

        <footer>
          <p>Floodin Pty. Ltd., 20 Airport Road, 6600 Plettenberg Bay, South Africa</p>
        </footer>
      </div>
    </div>
  );
};

export default PartnerReport;
